var _circle, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgIconLikeDefault = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 26.9999,
    cy: 26.9999,
    r: 25.9999,
    stroke: "white",
    strokeWidth: 1.99999
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.9986 22.5649C42.9986 20.4016 41.037 19.3234 39.0685 19.3234H30.4918C30.4918 19.3234 32.9333 14.3151 33.2394 13.2578C33.5455 12.2005 33.9628 10.4963 32.6064 9.57113C31.25 8.63903 29.6501 8.85467 28.3215 10.1415C28.3215 10.1415 22.1099 17.7374 18.771 20.2833V40.2052H36.3626C38.3312 40.2052 40.9327 39.447 41.1692 36.915C41.197 36.6298 41.3014 35.9829 40.564 34.9813C42.6021 33.5275 42.8665 31.1068 41.4544 29.4582C43.0056 27.9557 43.0056 26.015 42.2335 24.5125C42.9986 23.8448 42.9986 22.551 42.9986 22.551V22.5649Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3866 17.9392H12.3922C11.6238 17.9392 11.001 18.5621 11.001 19.3304V39.607C11.001 40.3754 11.6238 40.9982 12.3922 40.9982H17.3866C18.1549 40.9982 18.7777 40.3754 18.7777 39.607V19.3304C18.7777 18.5621 18.1549 17.9392 17.3866 17.9392Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLikeDefault, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/iconLikeDefault.476dd6e0.svg";
export { ForwardRef as ReactComponent };